import { useUser } from '../utils/hooks';
import EditUser from '../components/user/EditUser';

const UserSettingsView = () => {
  const user = useUser();
  const userValues = {
    id: user?.id,
    firstName: user?.firstName,
    lastName: user?.lastName,
    email: user?.email,
    updatedAt: user?.updatedAt,
    defaultUnitSystem: user?.defaultUnitSystem,
  };

  return <EditUser user={userValues} />;
};

export default UserSettingsView;
